import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "@material-tailwind/react";
import { Toaster } from 'react-hot-toast';
import { HeroUIProvider } from "@heroui/react";
import ReactGA from "react-ga4";

const TRACKING_ID = "G-Y6G3J76ZK1";
ReactGA.initialize(TRACKING_ID);

const RootComponent = () => {
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
      title: "Stabilix",
    });
  }, []);
  console.log = console.warn = console.error = console.info = console.debug = () => { };
  return (
    <HeroUIProvider>
      <BrowserRouter>
        <Toaster className="font-bold" />
        <App />
      </BrowserRouter>
    </HeroUIProvider>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<RootComponent />);

reportWebVitals();
